import { AxiosPromise, AxiosResponse } from 'axios'
import makeDate from '../utils/makeDate'
import request from '../utils/request'
import { IBallot, IQuestion } from './types'

export const postVote = (ballot: IBallot): AxiosPromise<IQuestion> =>
    request({
        url: `/api/vote/`,
        method: 'post',
        data: ballot,
    }).then((question: AxiosResponse<IQuestion>) => {
        makeDate(question)
        return question
    })

export const getVote = (questionID: string): AxiosPromise<IQuestion> =>
    request({
        url: `/api/vote/${questionID}`,
        method: 'get',
    }).then((question: AxiosResponse<IQuestion>) => {
        makeDate(question)
        return question
    })
